(() => {
  if (customElements.get('up-product-kit-contents')) return;

  class UpProductKitContents extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.track = this.querySelector('[data-kit-track]');
      this.slides = Array.from(this.querySelectorAll('[data-kit-slide]'));
      this.previousButton = this.querySelector('[data-kit-previous]');
      this.nextButton = this.querySelector('[data-kit-next]');

      if (!this.track || this.slides.length < 2) {
        this.previousButton?.setAttribute('hidden', '');
        this.nextButton?.setAttribute('hidden', '');
        return;
      }

      this.handlePrevious = this.handlePrevious.bind(this);
      this.handleNext = this.handleNext.bind(this);
      this.handleScroll = this.handleScroll.bind(this);
      this.handleResize = this.handleResize.bind(this);

      this.previousButton?.addEventListener('click', this.handlePrevious);
      this.nextButton?.addEventListener('click', this.handleNext);
      this.track.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleResize);

      requestAnimationFrame(() => this.updateButtons());
    }

    disconnectedCallback() {
      this.previousButton?.removeEventListener('click', this.handlePrevious);
      this.nextButton?.removeEventListener('click', this.handleNext);
      this.track?.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);
      this.initialized = false;
    }

    getStep() {
      const first = this.slides[0];
      if (!first || !this.track) return 0;
      const styles = window.getComputedStyle(this.track);
      const gap = Number.parseFloat(styles.columnGap || styles.gap || '0');
      return first.getBoundingClientRect().width + gap;
    }

    getIndex() {
      const step = this.getStep();
      if (!step) return 0;
      return Math.round(this.track.scrollLeft / step);
    }

    scrollToIndex(index) {
      const step = this.getStep();
      if (!step) return;
      const target = Math.max(0, Math.min(index, this.slides.length - 1));
      this.track.scrollTo({ left: target * step, behavior: 'smooth' });
    }

    handlePrevious() {
      const current = this.getIndex();
      this.scrollToIndex(current <= 0 ? this.slides.length - 1 : current - 1);
    }

    handleNext() {
      const current = this.getIndex();
      this.scrollToIndex(current >= this.slides.length - 1 ? 0 : current + 1);
    }

    handleScroll() {
      window.clearTimeout(this.scrollTimer);
      this.scrollTimer = window.setTimeout(() => this.updateButtons(), 80);
    }

    handleResize() {
      this.updateButtons();
    }

    updateButtons() {
      if (!this.track || !this.previousButton || !this.nextButton) return;
      const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const hasOverflow = maxScroll > 2;
      this.previousButton.hidden = !hasOverflow;
      this.nextButton.hidden = !hasOverflow;
    }
  }

  customElements.define('up-product-kit-contents', UpProductKitContents);
})();
